import Cookies from "js-cookie";
import fetchRequest from "../fetchRequest";
import formatNumber from "../../../../helpers/formatNumbers";
import debounce from "lodash.debounce";
import { assignPageNameAndFire } from "../../../../helpers/osTracking";

class TradeInBodyComponent {
    constructor(tradeInBody, OS_MODAL, emitter) {
        this.OS_MODAL = OS_MODAL;
        this.emitter = emitter;

        this.tradeInCookieName = "OnlineShopperTradeIn";
        this.orderIndex = 0;

        this.tradeInBody = tradeInBody;

        this.typeAheadInput = this.tradeInBody.querySelector('.trade-in__type-ahead-input');
        this.bodyInput = this.tradeInBody.querySelector('.trade-in__body');
        this.engineInput = this.tradeInBody.querySelector('.trade-in__engine');
        this.fuelTypeInput = this.tradeInBody.querySelector('.trade-in__fuel_type');
        this.doorsInput = this.tradeInBody.querySelector('.trade-in__doors');
        this.drivetrainInput = this.tradeInBody.querySelector('.trade-in__drivetrain');

        this.conditionContainer = this.tradeInBody.querySelector('.trade-in__condition-container');

        this.optionalFields = this.tradeInBody.querySelector('.trade-in__optional-fields');
        this.mileageInput = this.optionalFields.querySelector('.trade-in__input-mileage');
        this.balanceInput = this.optionalFields.querySelector('.trade-in__amount-input');

        this.clearFormCta = this.tradeInBody.querySelector('.trade-in__clear-form');

        this._attachTypeAhead();

        this.currentTradeIn = Cookies.getJSON(this.tradeInCookieName) || {};

        [ this.bodyInput, this.engineInput, this.fuelTypeInput, this.doorsInput, this.drivetrainInput ].forEach(elem =>
            elem.addEventListener('change', event => this._handleRefinementEvents(event))
        );

        this.conditionContainer.addEventListener("change", event => this._handleConditionChange(event));

        this.mileageInput.addEventListener("keyup", event => this._handleMileage(event));
        this.balanceInput.addEventListener("keyup", event => this._handleBalance(event));

        this.clearFormCta.addEventListener("click", () => this._handleClear());

        this.checkCTAs = this.checkCTAs.bind(this);
        this.emitter.on('primary-cta-clicked', this.checkCTAs);

        this._debouncedGetReport = debounce(this._getReport, 1000);
        this._debouncedPatchTradeIn = debounce(this._patchTradeIn, 1000);
    }

    init(fetchParams) {
        this.fetchParams = fetchParams;
        if (this.currentTradeIn) {
            this.orderIndex = this.currentTradeIn.refinementOrder ? this.currentTradeIn.refinementOrder.length : this.orderIndex;
            this._prepopulate(this.currentTradeIn);
        }
    }

    _attachTypeAhead() {
        const SNAP = window.SNAP;

        /* eslint-disable camelcase */
        /* The configure with options fucntion is not maintained by Cars.com
            testing of it's functionality is beyond the scope of our testing requirements.
            Testing of the callback function that is being passes is done in the
            tradeInCallback.spec.js file */
        if (SNAP && SNAP.configure_with_options) {
            SNAP.configure_with_options(
                {
                    css_selector: "#tradepending-vehicle-typeahead",
                    include_new_cars: false
                },
                /*istanbul ignore next*/
                async vehicle => {
                    this.currentTradein = await this._handleVehicle(vehicle);
                    if (this.currentTradein.select) {
                        this._populateRefinement(this.currentTradein);
                    }
                    this.typeAheadInput.setAttribute('disabled', true);
                    this.optionalFields.classList.remove("hidden");
                    assignPageNameAndFire('onlineShopper/tradeInMMYT');
                }
            );
        }
    }

    async _prepopulate(currentTradeIn) {
        if (currentTradeIn.ymmt) {
            this.typeAheadInput.value = currentTradeIn.ymmt;
            this.typeAheadInput.setAttribute("disabled", true);
            this.optionalFields.classList.remove('hidden');
        }

        if (currentTradeIn.odometer && currentTradeIn.odometer.amount) {
            this.mileageInput.value = formatNumber(currentTradeIn.odometer.amount, 'money');
        }

        if (currentTradeIn.balance) {
            this.balanceInput.value = formatNumber(currentTradeIn.balance, 'money');
        }

        let refinementElement;
        let elemInput;
        let refinementValue;
        if (currentTradeIn.refinementOrder) {
            currentTradeIn.refinementOrder.map((value, index) => {
                refinementElement = this.tradeInBody.querySelector(`.trade-in__${value}`);
                elemInput = refinementElement.querySelector("select");
                refinementValue = currentTradeIn[`${value}`];

                refinementElement.classList.add(this._refinementOrder(index));
                refinementElement.classList.remove('hidden');
                elemInput.innerHTML = `<option value=0 selected=true class="trade-in__refinement-option">${refinementValue}</option>`;
                elemInput.setAttribute('disabled', true);
            });
        }

        if (currentTradeIn.select && currentTradeIn.choices) {
            this._populateRefinement(currentTradeIn);
        }

        if (currentTradeIn.id && currentTradeIn.report_url) {
            await this._getReport();

            const inputArray = Array.from(this.tradeInBody.querySelectorAll('.trade-in__condition-options .trade-in__option'));

            let input;
            inputArray.map(element => {
                input = element.querySelector('.trade-in__condition-input');
                input.getAttribute('value') === currentTradeIn.selectedCondition ? input.setAttribute('checked', true) : input.removeAttribute('checked');
            });
        }
    }

    _populateRefinement(currentTradeIn) {
        const elemToShow = this.tradeInBody.querySelector(`.trade-in__${currentTradeIn.select}`);
        const elemInput = elemToShow.querySelector("select");
        this._buildSelectOptions(elemInput, currentTradeIn.choices);
        elemToShow.classList.remove("hidden");
        elemToShow.classList.add(this._refinementOrder(this.orderIndex));
        this.orderIndex++;
    }

    _disableRefinement(refinementName) {
        const elemToDisable = this.tradeInBody.querySelector(`.trade-in__${refinementName} select`);
        elemToDisable.setAttribute('disabled', true);
    }

    _buildSelectOptions(element, choices) {
        let optionsString = `<option value="-1" class="trade-in__refinement-option">Select an option</option>`;
        let isSelected;
        choices.map((value, index) => {
            optionsString += `<option value=${index} ${isSelected} class="trade-in__refinement-option">${value}</option>`;
        });

        element.innerHTML = optionsString;
    }

    _enableCondition(currentTradeIn) {
        const valueContainer = this.tradeInBody.querySelector('.trade-in__value-container');
        const valueAmount = valueContainer.querySelector(`.trade-in__value-amount`);
        const primaryCTA = this.OS_MODAL.querySelector('.payment-details__primary-cta');
        const secondaryCTA = this.OS_MODAL.querySelector('.payment-details__secondary-cta');

        if (!this.tradeInBody.classList.contains("hidden")) {
            primaryCTA.classList.remove('hidden');
            secondaryCTA.classList.add('hidden');
        }

        this.conditionContainer.classList.remove('hidden');
        valueContainer.classList.remove('hidden');
        valueAmount.innerHTML = `$${formatNumber(currentTradeIn.customer_estimate, "money")}`;
    }

    _estimateError() {
        const errorContainer = this.OS_MODAL.querySelector('.trade-in__no-trade-in-container');
        errorContainer.classList.remove('hidden');
        this.checkCTAs();
    }

    _tradeInConditionMap(currentTradeIn, condition) {
        switch (condition) {
            case "Great":
                currentTradeIn.customer_estimate = currentTradeIn.tp_tradein_high;
                currentTradeIn.selectedCondition = condition;
                currentTradeIn.condition = "high";
                break;
            case "Fair":
                currentTradeIn.customer_estimate = currentTradeIn.tp_tradein_low;
                currentTradeIn.selectedCondition = condition;
                currentTradeIn.condition = "low";
                break;
            case "Good":
            default:
                currentTradeIn.customer_estimate = currentTradeIn.tp_tradein_target;
                currentTradeIn.selectedCondition = condition;
                currentTradeIn.condition = "target";
                break;
        }
    }

    async _handleRefinementEvents(event) {
        const selectedName = event.target.name;
        this.currentTradeIn[`${selectedName}`] = this.currentTradeIn.choices[event.target.value];
        this.currentTradeIn.refinementOrder.push(selectedName);

        const queryParam = this._buildTradePendingQuery(this.currentTradeIn);
        const getResponse = await fetchRequest.getTradePending(this.fetchParams, queryParam);

        if (getResponse) {
            if (getResponse.select && getResponse.choices) {
                this._disableRefinement(selectedName);

                this.currentTradeIn.select = getResponse.select;
                this.currentTradeIn.choices = getResponse.choices;

                Cookies.set(this.tradeInCookieName, this.currentTradeIn, { expires: 7 });
                this.currentTradeIn = await this._patchTradeIn();
                this._populateRefinement(this.currentTradeIn);
            } else if (getResponse.id && getResponse.report_url) {
                this._disableRefinement(selectedName);

                this.currentTradeIn.select = "";
                this.currentTradeIn.choices = [];
                this.currentTradeIn.id = getResponse.id;
                this.currentTradeIn.report_url = getResponse.report_url;
                Cookies.set(this.tradeInCookieName, this.currentTradeIn, { expires: 7 });
                this._getReport();
            }
        }
    }

    async _getReport() {
        let reportQuery = `vehicle_id=${this.currentTradeIn.id}`;
        reportQuery += this.currentTradeIn.odometer && this.currentTradeIn.odometer.amount ? `&mileage=${this.currentTradeIn.odometer.amount}` : "";
        reportQuery += this.currentTradeIn.zipCode ? `&zip_code=${this.currentTradeIn.zipCode}` : "";

        const reportResponse = await fetchRequest.getTradePendingReport(this.fetchParams, reportQuery);

        if (reportResponse && reportResponse.report && reportResponse.report.tradein && reportResponse.report.tradein.target) {
            this.currentTradeIn.tp_tradein_low = reportResponse.report.tradein.low;
            this.currentTradeIn.tp_tradein_target = reportResponse.report.tradein.target;
            this.currentTradeIn.tp_tradein_high = reportResponse.report.tradein.high;

            const conditionToMap = this.currentTradeIn.selectedCondition ? this.currentTradeIn.selectedCondition : "Good";
            this._tradeInConditionMap(this.currentTradeIn, conditionToMap);
            this.currentTradeIn.estimateError = false;
            Cookies.set(this.tradeInCookieName, this.currentTradeIn, { expires: 7 });
            this.currentTradeIn = await this._patchTradeIn();
            this._enableCondition(this.currentTradeIn);
        } else {
            this.currentTradeIn.estimateError = true;
            Cookies.set(this.tradeInCookieName, this.currentTradeIn, { expires: 7 });
            this._estimateError();
        }
        return this.currentTradeIn;
    }

    _handleMileage(event) {
        let mileageAmount = parseInt((event.target.value).replace(/\D/g, ""));

        if (!this.currentTradeIn.odometer) {
            this.currentTradeIn.odometer = {
                unit: "mi"
            };
        }

        this.currentTradeIn.odometer.amount = mileageAmount ? mileageAmount : 0;
        Cookies.set(this.tradeInCookieName, this.currentTradeIn, { expires: 7 });

        if (this.currentTradeIn.id && this.currentTradeIn.report_url) {
            this._debouncedGetReport();
        }

        this.mileageInput.value = formatNumber(this.currentTradeIn.odometer.amount, 'money');
    }

    async _patchTradeIn() {
        const patchResponse = await fetchRequest.patchTradeIn(this.fetchParams, this.currentTradeIn);
        Cookies.set(this.tradeInCookieName, patchResponse, { expires: 7 });
        this.emitter.emit('user-updated-trade-in');
        return patchResponse;
    }

    _handleBalance(event) {
        const balanceInput = this.tradeInBody.querySelector('.trade-in__amount-input');

        let balanceAmount = parseInt((event.target.value).replace(/\D/g, ''));
        this.currentTradeIn.balance = balanceAmount ? balanceAmount : 0;

        balanceInput.value = formatNumber(this.currentTradeIn.balance, 'money');
        Cookies.set(this.tradeInCookieName, this.currentTradeIn, { expires: 7 });
        this._debouncedPatchTradeIn();
    }

    async _handleClear() {
        const errorContainer = this.tradeInBody.querySelector('.trade-in__no-trade-in-container');
        const valueContainer = this.tradeInBody.querySelector('.trade-in__value-container');
        const valueAmount = valueContainer.querySelector(`.trade-in__value-amount`);

        const deleted = await fetchRequest.deleteTradePending(this.fetchParams);

        if (deleted) {
            this.typeAheadInput.value = '';
            this.typeAheadInput.removeAttribute('placeholder');
            this.typeAheadInput.removeAttribute('disabled');

            if (this.currentTradeIn && this.currentTradeIn.select) {
                const selectElem = this.tradeInBody.querySelector(`.trade-in__${this.currentTradeIn.select}`);
                selectElem.classList.remove(this._refinementOrder(this.orderIndex - 1));
                selectElem.classList.add('hidden');
                selectElem.removeAttribute('disabled');
            }

            if (this.currentTradeIn && this.currentTradeIn.refinementOrder) {
                let currentElem;
                this.currentTradeIn.refinementOrder.map((value, index) => {
                    currentElem = this.tradeInBody.querySelector(`.trade-in__${value}`);
                    currentElem.classList.remove(this._refinementOrder(index));
                    currentElem.classList.add('hidden');
                    currentElem.querySelector('select').removeAttribute('disabled');
                });
            }
            this.conditionContainer.classList.add('hidden');
            this.currentTradeIn.selectedCondition = "";
            this.optionalFields.classList.add('hidden');
            this.mileageInput.value = '';
            this.balanceInput.value = '';

            valueContainer.classList.add('hidden');
            errorContainer.classList.add('hidden');
            valueAmount.innerHTML = 'N/A';

            this.orderIndex = 0;
            Cookies.remove(this.tradeInCookieName);
            this.emitter.emit('user-updated-trade-in');
            this.checkCTAs();
        }
    }

    _handleConditionChange(event) {
        const inputArray = Array.from(this.tradeInBody.querySelectorAll('.trade-in__condition-options .trade-in__option'));
        const selectionValue = event.target.value;

        let input;
        inputArray.map(element => {
            input = element.querySelector('.trade-in__condition-input');
            input.getAttribute('value') === selectionValue ? input.setAttribute('checked', true) : input.removeAttribute('checked');
        });

        this._tradeInConditionMap(this.currentTradeIn, selectionValue);
        this._enableCondition(this.currentTradeIn);
        Cookies.set(this.tradeInCookieName, this.currentTradeIn, { expires: 7 });
        this._patchTradeIn();
    }

    _buildTradePendingQuery(tpOBject, selectName = "", selectValue = "") {
        let query = "";
        const paramsArray = [
            "make",
            "model",
            "trim",
            "year",
            "body",
            "engine",
            "fuel_type",
            "doors",
            "drivetrain"
        ];

        paramsArray.map(value => {
            if (tpOBject.hasOwnProperty(value)) {
                query += `&${value}=${tpOBject[value]}`;
            }
        });

        if (selectName && selectValue) {
            query += `&${selectName}=${selectValue}`;
        }

        return query;
    }

    _refinementOrder(number) {
        switch (number) {
            case 0:
                return "first";
            case 1:
                return "second";
            case 2:
                return "third";
            case 3:
                return "fourth";
            case 4:
                return "fifth";
            default:
                return "no-order";
        }
    }

    /* istanbul ignore next */
    async _handleVehicle(vehicle) {
        let response;
        this.currentTradeIn = {
            make: vehicle.make,
            model: vehicle.model,
            trim: vehicle.trim,
            year: vehicle.year,
            ymmt: vehicle.ymmt,
            yn: "yes"
        };

        const getResponse = await fetchRequest.getTradePending(this.fetchParams, this._buildTradePendingQuery(vehicle));
        if (getResponse.select) {
            this.currentTradeIn.select = getResponse.select;
            this.currentTradeIn.choices = getResponse.choices;
            if (!this.currentTradeIn.refinementOrder) {
                this.currentTradeIn.refinementOrder = [];
            }
            Cookies.set(this.tradeInCookieName, this.currentTradeIn, { expires: 7 });
            response = await this._patchTradeIn(this.fetchParams, this.currentTradeIn);
        } else if (getResponse.report_url && getResponse.id) {
            this.currentTradeIn.select = '';
            this.currentTradeIn.choices = [];
            this.currentTradeIn.report_url = getResponse.report_url;
            this.currentTradeIn.id = getResponse.id;
            Cookies.set(this.tradeInCookieName, this.currentTradeIn, { expires: 7 });
            response = await this._getReport();
        }
        return response;
    }

    checkCTAs() {
        const primaryCTA = this.OS_MODAL.querySelector('.payment-details__primary-cta');
        const secondaryCTA = this.OS_MODAL.querySelector('.payment-details__secondary-cta');
        if (this.currentTradeIn && this.currentTradeIn.selectedCondition) {
            primaryCTA.classList.remove("hidden");
            secondaryCTA.classList.add("hidden");
            assignPageNameAndFire('onlineShopper/tradeInMMYT');
        } else if (this.currentTradeIn && this.currentTradeIn.estimateError) {
            primaryCTA.classList.remove("hidden");
            secondaryCTA.classList.add("hidden");
        } else {
            primaryCTA.classList.add("hidden");
            secondaryCTA.classList.remove("hidden");
            assignPageNameAndFire('onlineShopper/tradeIn');
        }
    }
}

export default TradeInBodyComponent;